import * as React from 'react'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { BrandsAndDelegations, SelectWithLabel } from 'components/Form'
import { surveys as surveysApi } from 'api'
import SurveysList from './SurveysList'
import SurveyDetail from './SurveyDetail'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'
import dkvConfiguration from 'constants/dkv.constants'

const SurveyView = () => {
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [surveysData, setSurveysData] = React.useState({})
  const [isOpenModal, setIsOpenModal] = React.useState(false)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const [valuesToEdit, setValuesToEdit] = React.useState({})
  const [surveyToRemove, setSurveyToRemove] = React.useState({})
  const [removing, setRemoving] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(false)
  const [errorMessageModal, setErrorMessageModal] = React.useState(null)
  const [search, setSearch] = React.useState('')
  const orderOptions = [
    { value: 'asc', label: I18n.t('order_by_az') },
    { value: 'desc', label: I18n.t('order_by_za') }
  ]
  const [order, setOrder] = React.useState(orderOptions[0])

  React.useEffect(()=> {
    getSurveys()
  }, [order, brands, delegations, search])

  React.useEffect(()=> {
    if (!isOpenModal)
      setValuesToEdit({})
  }, [isOpenModal])

  const onChange = (value, type) => {
    setErrorMessage(false)

    if (type === 'sort') {
      setOrder(value)
    }
    else if (type === 'brand') {
      setBrands(value)
    }
    else if (type === 'delegation') {
      setDelegations(value)
    }
    else if (type === 'search') {
      setSearch(value)
    }
  }

  const getSurveys = async () => {
    setErrorMessage(false)
    let brandsToSend = []
    let delegationsToSend = []
    brands.forEach(it => {
      if (it.value !== 'all')
        brandsToSend.push(it.value)
    })
    delegations.forEach(it => {
      if (it.value !== 'all')
        delegationsToSend.push(it.value)
    })

    try {
      const { data } = await surveysApi.get({
        sort: order.value,
        brands: brandsToSend.join(),
        delegations: delegationsToSend.join(),
        name: search,
      })
      setSurveysData(data)

      if (!data.surveys.length === 0) setErrorMessage(I18n.t('surveys_not_data'))
    } catch (error) {
      console.error(error.message)
    }
  }

  const save = async (survey) => {
    setIsSubmitting(true)

    const brandsToSave = []
    survey.brands.forEach(it => {
      const id = it.value || it._id
      if (id !== 'all' ) {
        brandsToSave.push({ _id: id, name: it.label || it.name })
      }
    })
    const delegationsToSave = []
    survey.delegations.forEach(it => {
      const id = it.value || it._id
      if (id !== 'all') {
        delegationsToSave.push({ _id: id, name: it.label || it.name, brand: it.brand || it.data.brand || it.data.data.brand })
      }
    })

    const data = {
      _id: survey._id,
      brands: brandsToSave,
      delegations: delegationsToSave,
      name: survey.name,
      identifier: survey.identifier,
      type: survey.type,
      buttonLabel: survey.buttonLabel,
      content: survey.content,
      contentHtml: survey.contentHtml,
      variables: survey.variables
    }

    if (!dkvConfiguration.isDKV) data.type = ''

    if (data._id) {
      try {
        await surveysApi.put(data._id, data)
        setIsOpenModal(false)
        getSurveys(brands, delegations)
        setIsSubmitting(false)
      } catch (error) {
        if (error.data.type) setErrorMessageModal(I18n.t(error.data.type))
        setIsSubmitting(false)
      }
    } else {
      try {
        await surveysApi.post(data)
        setIsOpenModal(false)
        getSurveys(brands, delegations)
        setIsSubmitting(false)
      } catch (error) {
        if (error.data.type) setErrorMessageModal(I18n.t(error.data.type))
        setIsSubmitting(false)
      }
    }
  }

  const openModalToEdit = (values) => {
    setValuesToEdit(values)
    setIsOpenModal(true)
  }

  const deleteSurvey = async (values) => {
    setRemoving(true)

    try {
      await surveysApi.remove(values._id)
      getSurveys(brands, delegations)
      setIsOpenModalDelete(false)
      setSurveyToRemove({})
      setRemoving(false)
    } catch (error) {
      setIsOpenModalDelete(false)
      setSurveyToRemove({})
      setRemoving(false)
    }
  }

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 surveys-configuration'>
        <div className='wrapper-surveys section mb-4'>
          <div className='surveys-header-container'>
            <div className='surveys-header'>
              <h1>{I18n.t('dashboard_surveys')}</h1>
              <legend dangerouslySetInnerHTML={{ __html: I18n.t('surveys_subtitle') }} />
            </div>
            <a href='https://www.surveymonkey.com/user/sign-up/' target='_blank' rel='noopener noreferrer'>
              <figure className='surveys-logo' title='Survey Monkey'>
                <img src={getStaticImage('/logos/survey-monkey-logo-vertical-sabaeus.png')} alt='Survey Monkey logo' />
              </figure>
            </a>
          </div>
          <div className='seccion-1'>
            <BrandsAndDelegations
              onChangeBrands={value => onChange(value, 'brand')}
              currentBrands={brands || []}
              onChangeDelegations={value => onChange(value, 'delegation')}
              currentDelegations={delegations || []}
            />
            <div className='right-filters'>
              <div className='input-search-wrapper'>
                <i className='fa fa-search'/>
                <input type='text' placeholder={I18n.t('dashboard_search')} onChange={({ target }) => onChange(target.value, 'search')} ></input>
              </div>
              <div className='wrapper-filter'>
                <label htmlFor='order'>{I18n.t('dashboard_order-by')}</label>
                <SelectWithLabel
                  name='order'
                  options={orderOptions}
                  value={order}
                  onChange={value => onChange(value, 'sort')}
                  classNameWrapper='surveys-selector'
                />
              </div>
            </div>
          </div>
          <div className='wrapper-error animated fadeIn'>
            <small className='error'>{errorMessage}</small>
          </div>

          <div className='seccion-2'>
            {surveysData.surveys && (
              <SurveysList
                surveys={surveysData.surveys}
                edit={openModalToEdit}
                remove={values => { setIsOpenModalDelete(true); setSurveyToRemove(values) }}
              />
            )}
          </div>
          <div className={`add-survey`} onClick={()=>{setIsOpenModal(true)}}>
            <img src={getStaticImage('/icons/orange-brand/icon-add.svg')} alt='Add survey'/>
            <span>{I18n.t('dashboard_add-survey')}</span>
          </div>

          {isOpenModal && (
            <SurveyDetail
              isOpen={isOpenModal}
              toggle={() => setIsOpenModal(!isOpenModal)}
              save={save}
              valuesToEdit={valuesToEdit}
              variables={surveysData.varFields}
              isSubmitting={isSubmitting}
              errorMessageModal={errorMessageModal}
              setErrorMessageModal={setErrorMessageModal}
            />
          )}

          <ModalDelete
            isOpen={isOpenModalDelete}
            toggle={() => setIsOpenModalDelete(!isOpenModalDelete)}
            header={I18n.t('dashboard_delete-survey')}
            text1={I18n.t('surveys_remove_survey_title')}
            text2={I18n.t('dashboard_action-cannot-reversed')}
            event={() => deleteSurvey(surveyToRemove)}
            isSubmitting={removing}
          />

        </div>
      </Container>
    </div>
  )
}

export default SurveyView
